export const englishTranslations = {
  // Meta & General
  pageTitle: "AI Marketing Videos for Businesses | Future Level Switzerland",
  pageDescription: "Automated video production with AI – Future Level helps businesses save time and money while increasing marketing performance.",
  
  // Navigation
  home: "Home",
  services: "Services",
  whyFutureLevel: "Why Future Level?",
  blog: "Blog",
  contact: "Contact",
  breadcrumbNavigation: "Breadcrumb navigation",
  
  // Pricing Page
  pricing: "Pricing",
  pricingSubtitle: "Transparent pricing for AI video production with the best value for money",
  pricingDescription: "Discover our transparent pricing models for AI-based video production: From single videos to monthly subscriptions.",
  
  // Service Names
  productVideos: "Product Videos",
  kiVideoProductShowcase: "AI Product Videos",
  explainerVideos: "Explainer Videos",
  socialMediaAds: "Social Media Ads",
  reels: "Reels",
  
  // Service Descriptions
  productVideosDesc: "Showcase your products in the best light – automatically, quickly, convincingly.",
  explainerVideosDesc: "Complex content simply and comprehensibly explained by AI.",
  socialMediaAdsDesc: "High-performance short videos for your campaigns on Instagram, Facebook, TikTok & more.",
  reelsDesc: "Maximum reach thanks to trendy AI reels in your branding.",
  
  // Hero Section
  heroTitle: "Future-Oriented Video Marketing with AI",
  heroSubtitle: "Save time & costs, maximize impact",
  contactUs: "Contact Us",
  learnMore: "Learn More",
  
  // Why Future Level
  whyFutureLevelSubtitle: "Our AI technology creates videos faster than any agency – without actors, cameras, or studio production.",
  costSaving: "Cost Saving",
  timeSaving: "Time Saving",
  increaseSales: "Increase Sales",
  targetAudience: "Tailored for Your Target Audience",
  costSavingDesc: "Reduce your production costs by up to 70% compared to conventional video productions.",
  timeSavingDesc: "Receive your finished videos within days instead of weeks or months.",
  increaseSalesDesc: "Boost your conversion rate and sales with compelling visual content.",
  targetAudienceDesc: "Each video is precisely tailored to your target audience and industry.",
  
  // Why AI Videos Section
  whyKIVideosTitle: "AI Social Media Videos: 300% More Engagement & 70% Cost Savings",
  whyKIVideosPoint1: "Expert team using advanced AI tools for Instagram, TikTok & Facebook videos - always at the cutting edge of technology",
  whyKIVideosPoint2: "Team composed exclusively of professional video editors with years of experience in digital video production",
  whyKIVideosPoint3: "Complete focus on your success through customized AI-powered video strategies",
  whyKIVideosPoint4: "Professional team with expertise in all social media formats (Instagram Reels, Facebook Ads, TikTok)",
  
  // Services Section
  ourServices: "Our Services",
  servicesSubtitle: "Professional AI-based marketing videos that effectively convey your message.",
  
  // Testimonials
  clientTestimonials: "Client Testimonials",
  testimonialsSubtitle: "What our clients say about us",
  testimonial1: "Future Level's AI videos have increased the conversion rate in our online shop by 35%. Incredible value for money!",
  testimonial2: "We use the explainer videos for complex consulting topics. Our clients are thrilled with how understandably the content is prepared.",
  testimonial3: "The social media ads have helped our clinic achieve significantly higher local awareness. The ROI is impressive.",
  
  // Blog Section
  latestBlogPosts: "Latest Blog Posts",
  blogSubtitle: "Trends and tips about video marketing and AI in marketing",
  blogTitle1: "Video Marketing Trends 2025",
  blogExcerpt1: "Which video formats and technologies dominate marketing this year? Insights and forecasts.",
  blogTitle2: "AI in Marketing - Revolution or Hype?",
  blogExcerpt2: "How artificial intelligence is sustainably changing marketing and what opportunities arise for companies.",
  blogTitle3: "Case Study: Successful Video Campaigns",
  blogExcerpt3: "Analysis of three particularly successful video campaigns and what you can learn from them.",
  readMore: "Read More",
  viewAllPosts: "View All Posts",
  
  // Blog Page
  blogPageTitle: "Expert Knowledge: Video Marketing & AI",
  blogPageSubtitle: "Current trends, practical tips and success stories from the world of AI-based video marketing",
  blogMetaDescription: "The Future Level blog offers expert knowledge on AI video marketing, trends, and best practices for businesses in Switzerland.",
  backToBlog: "Back to Blog",
  blogContentPlaceholder: "This section contains detailed information on the topic. On a live website, the full article content would be here.",
  blogSubheading1: "Key Insights",
  blogSubheading2: "Practical Applications",
  blogSubheading3: "Conclusion and Outlook",
  blogCTA: "Would you like to learn more about our AI video solutions?",
  
  // Contact Form
  contactSubtitle: "Ready to revolutionize your video marketing strategy with AI? Fill out our contact form – we'll get back to you within 24 hours.",
  fullName: "Full Name",
  email: "Email",
  company: "Company",
  phone: "Phone Number",
  projectDescription: "Project Description",
  send: "Send",
  formSubmitSuccess: "Message Sent!",
  formSubmitMessage: "Thank you for your inquiry. We will contact you within 24 hours.",
  
  // Clients Section
  trustedBy: "Trusted By These Companies",
  
  // Legal Page
  tableOfContents: "Table of Contents",
  legalTitle: "Legal Notice",
  legalDescription: "Company details and legal information about our AI video marketing agency in Kriens, Switzerland",
  contactInfo: "Contact Information",
  companyDetails: "Company Details",
  vatInfo: "VAT Information",
  authorizedRepresentative: "Authorized Representative",
  legalNotices: "Legal Notices",
  disclaimer: "Disclaimer",
  copyright: "Copyright",
  lastUpdated: "Last updated: May 2025",
  backToTop: "Back to Top",
  collapseTOC: "Collapse table of contents",
  expandTOC: "Expand table of contents",
  navigateToSection: "Navigate to section",
  
  // New SEO-focused keywords based on research
  kiVideo: "AI Video",
  videoMarketing: "Video Marketing",
  socialMediaMarketing: "Social Media Marketing",
  digitalMarketing: "Digital Marketing",
  aiContentCreation: "AI Content Creation",
  
  // Industry-specific terms
  financeSector: "Financial Sector",
  luxuryBrands: "Luxury Brands",
  tourism: "Tourism Industry",
  healthcare: "Healthcare",
  startups: "Startups and Tech Companies",
  
  // Location specific
  zurich: "Zurich",
  geneva: "Geneva",
  basel: "Basel",
  bern: "Bern",
  lausanne: "Lausanne",
  
  // Accessibility enhanced translations
  skipToContent: "Skip to main content",
  mainContent: "Main content",
  mainNavigation: "Main navigation",
  closeMenu: "Close menu",
  openMenu: "Open menu",
  
  // Footer
  footerDescription: "Future Level - Your partner for AI-based marketing videos in Switzerland. Boost your success with innovative video solutions.",
  quickLinks: "Quick Links",
  allRightsReserved: "All rights reserved.",
  impressum: "Imprint",
  privacy: "Privacy Policy",
  terms: "Terms & Conditions"
};
